import React, { useState } from "react";
import { TagFilterProps, TagsFilterProps } from "./type";
import i18next from "i18next";

const TagsFilter = ({
    filter,
    clear,
    tags,
    handleClick,
    useUrls = false,
    activeFilters = [],
}) => {
    const [active, setActive] = useState(null);

    const defaultHandleClick = (tag) => {
        if (tag === active) {
            clear();
            setActive(null);
        } else {
            filter(tag);
            setActive(tag);
        }
    };

    const handleFilterClick = (tag) => {
        if (!handleClick) {
            defaultHandleClick(tag);
            return;
        }
        handleClick(tag);
    };

    return (
        <div className="tag-filter__container">
            {Object.keys(tags).map((keyName) => {
                return (
                    <TagFilter
                        setActive={() => {
                            handleFilterClick(tags[keyName].filter);
                        }}
                        active={
                            active === tags[keyName].filter ||
                            activeFilters.includes(tags[keyName].filter)
                        }
                        key={tags[keyName].hintText}
                        icon={tags[keyName].icon}
                        url={tags[keyName].url || ""}
                        displayText={tags[keyName].hintText}
                        clear={clear}
                        isUrl={useUrls}
                    />
                );
            })}
        </div>
    );
};

const TagFilter = ({ active, icon, displayText, setActive, isUrl, url }) => {
    const { iconPath } = reactConfig;
    const activeClass = active ? "tag-filter--active" : "";

    if (isUrl) {
        return (
            <a className={`tag-filter ${activeClass}`} href={url}>
                <img alt={icon} src={`${iconPath}/${icon}.svg`} />
                <p>{i18next.t(displayText)}</p>
            </a>
        );
    }
    return (
        <div className={`tag-filter ${activeClass}`} onClick={setActive}>
            <img alt={icon} src={`${iconPath}/${icon}.svg`} />
            <p>{i18next.t(displayText)}</p>
        </div>
    );
};

TagFilter.propTypes = TagFilterProps;
TagsFilter.propTypes = TagsFilterProps;

export default TagsFilter;
